import { Tooltip } from "@mantine/core";
import type { ReactNode } from "react";
import { useTranslation } from "react-i18next";

interface PermissionTooltipProps {
  children: ReactNode;
  disabled: boolean;
}

const PermissionTooltip = ({ children, disabled }: PermissionTooltipProps) => {
  const { t } = useTranslation();

  if (!disabled) {
    return <>{children}</>;
  }

  return (
    <Tooltip label={t("common.youDontHavePermission")} withArrow>
      <div>{children}</div>
    </Tooltip>
  );
};

export default PermissionTooltip;
